import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propNumber } from '../../../../helpers/custom-prop-types';
import { viewPrice } from '../../../../helpers/solution';
import MoneyCircleIcon from '../../../Icon/Svg/MoneyCircleIcon';
const SolutionPrice = (props) => {
    const { price: rawPrice } = props;
    const price = useMemo(() => `${viewPrice(rawPrice)}万円程度`, [rawPrice]);
    return (_jsxs("div", Object.assign({ className: 'ui-solution-price' }, { children: [_jsx(MoneyCircleIcon, {}), _jsx("span", Object.assign({ className: 'price-text' }, { children: price }))] })));
};
SolutionPrice.propTypes = {
    price: propNumber().isRequired,
};
export default SolutionPrice;
